import { omnichannelPaths } from './omnichannel.paths';

export const redirectURL = (originalUrl: string) =>
    `${omnichannelPaths.login}?next=${originalUrl}`;
